import React from "react";
import PropTypes from "prop-types";
import "url-search-params-polyfill";
import IndexTable from "../../components/table/index.js";
import SelectOption from "./item";
import { I18n } from "../../i18n";

const SelectOptions = (props) => {
  const { path } = { ...props };

  // option uses common texts for translation
  const i18nProps = {
    i18n: props.i18n,
    i18nCommon: I18n[props.lang].common,
  };

  return (
    <IndexTable
      {...props}
      {...i18nProps}
      path={path}
      columns={[
        { id: "id", title: "ID" },
        { id: "langKey", title: "Language Key" },
        { id: "ua", title: "UA" },
        { id: "en", title: "EN" },
        {
          id: "active",
          title: "Active",
          displayFunc: (r) => (r.active ? "True" : "False"),
        },
      ]}
      onEditItem={(itemId, item, handleItemSave) => {
        return (
          <SelectOption
            serviceClass={props.serviceClass}
            {...i18nProps}
            item={item}
            itemId={itemId}
            indexPath={path}
            handleItemSave={handleItemSave}
            isEditable={true}
            {...props}
          />
        );
      }}
      onViewItem={(itemId, item) => {
        return (
          <SelectOption
            serviceClass={props.serviceClass}
            {...i18nProps}
            item={item}
            itemId={itemId}
            indexPath={path}
            isEditable={false}
            {...props}
          />
        );
      }}
    />
  );
};

SelectOptions.propTypes = {
  i18n: PropTypes.object.isRequired,
  api: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  serviceClass: PropTypes.any.isRequired,
};

export default SelectOptions;
